// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"RY-z","sponsoredTooltipWrapper":"SY-z","sponsoredTooltip":"TY-z","newCard":"UY-z"};